import { Configuration, AgenciesApi, UsersApi } from "@socotec.io/user-management-sdk";
import { useOidcStore } from "vue3-oidc";

// Contrairement aux autres SDK typescript-fetch de l'app, le SDK
// user-management n'ajoute pas le préfixe "Bearer" : il écrit dans le header
// Authorization la valeur exacte renvoyée par `accessToken`. Ne pas retirer le
// préfixe. Getter pour que le token soit relu à chaque requête.
const tokenGetter = () => `Bearer ${useOidcStore().state.value.token}`;

const userManagementConfiguration = new Configuration({
  basePath: import.meta.env.VITE_APP_USER_MANAGEMENT_REST_API_URL,
  accessToken: tokenGetter,
});

export const agencyClient = new AgenciesApi(userManagementConfiguration);
export const userClient = new UsersApi(userManagementConfiguration);
